import CopyIcon from 'assets/images/shopping/CopyIcon';
import { IProductDelivery } from 'types/orders';
import { copyTextToClipboard } from 'views/TrackingOrder/trackingOrder.utils';

interface IPreparationProductRowProps {
  product: IProductDelivery;
  quantity: number;
}

/**
 * Formatea las pills del producto en un string legible.
 * @param pills - Objeto con las pills del producto
 * @returns String formateado con las especificaciones
 */
const formatProductSpecs = (pills?: Record<string, string>): string => {
  if (!pills || Object.keys(pills).length === 0) return '';

  const specs = Object.values(pills).filter(Boolean);
  return specs.join(' - ');
};

/**
 * Fila de producto dentro del checklist de preparación.
 * Muestra el nombre, care status, especificaciones y cantidad.
 */
const PreparationProductRow = ({ product, quantity }: IPreparationProductRowProps) => {
  const productName = product.name || 'Sin nombre';
  const nudosCareName = product.nudosCareName;
  const hasNoCare = !nudosCareName || nudosCareName === 'Free';
  const specs = formatProductSpecs(product.pills);

  const textToCopy = [productName, specs].filter(Boolean).join(' - ');

  return (
    <div className="preparationProductRow">
      <div className="productInfo">
        <span className="productName">{productName}</span>
        <span className={`careBadge ${hasNoCare ? 'noCare' : ''}`}>
          {hasNoCare ? 'No Care' : nudosCareName}
        </span>
        {specs && <span className="productSpecs">{specs}</span>}
        <button
          className="copyButton"
          onClick={() => copyTextToClipboard(textToCopy)}
          aria-label="Copiar información del producto"
        >
          <CopyIcon />
        </button>
      </div>
      <span className="productQuantity">{quantity} Unidad{quantity > 1 ? 'es' : ''}</span>
    </div>
  );
};

export default PreparationProductRow;

